export function getFilters(data) {
	const drug = data.map(data => data.drug)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value !== undefined)
		.sort();
	
	const drugArray = Array.from(
		new Set(
			data.flatMap(item => item.drugArray || [])
		)
	).filter(Boolean).sort();

	const assignee = data.map(data => data.assignee)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value)
		.sort();

	const assigneeArray = Array.from(
		new Set(
			data.flatMap(item => item.assigneeArray || [])
		)
	).filter(Boolean).sort();

	const conditionsTreated = data.map(data => data.conditionsTreated)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value !== undefined)
		.sort();
	
	const conditionsTreatedArray = Array.from(
		new Set(
			data.flatMap(item => item.conditionsTreatedArray || [])
		)
	).filter(Boolean).sort();

	const patentType = data.map(data => data.patentType)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value !== undefined)
		.sort();

	const patentTypeArray = Array.from(
		new Set(
			data.flatMap(item => item.patentTypeArray || [])
		)
	).filter(Boolean).sort();

	const statusFdaApproval = data.map(data => data.statusFdaApproval)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value && value !== undefined)
		.sort();

	const statusOPBook = data.map(data => data.statusOPBook)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value !== undefined)
		.sort();

	const status = data.map(data => data.status)
		.filter((value, index, self) => self.indexOf(value) === index)
		.filter(value => value !== undefined)
		.sort();

	return {
		drug,
		drugArray,
		assignee,
		assigneeArray,
		conditionsTreated,
		conditionsTreatedArray,
		patentType,
		patentTypeArray,
		statusFdaApproval,
		statusOPBook,
		status
	}
}

export function applyFilters(selectedFilters, setSelectedFilters, filter, item) {
	let copiedSelectedFilters = { ...selectedFilters };

	if (copiedSelectedFilters[filter]?.includes(item)) {
		const idx = copiedSelectedFilters[filter].findIndex(elem => elem === item);

		setSelectedFilters(selectedFilters => ({
			...selectedFilters,
			[filter]: [
				...copiedSelectedFilters[filter].slice(0, idx),
				...copiedSelectedFilters[filter].slice(idx + 1),
			]
		}));

	} else {
		const string = [item];
		setSelectedFilters(selectedFilters => ({
			...selectedFilters,
			[filter]: [
				...copiedSelectedFilters[filter],
				...string
			]
		}));
	}
}

export function applyPatentNoFilter(setSelectedFilters, patent) {
	setSelectedFilters(selectedFilters => ({
		...selectedFilters,
		patentNo: patent,
	}));
}
